<template>
  <div
    id="modal_overlay"
    class="backdrop overflow-hidden z-50 absolute inset-0 h-full w-full flex justify-center items-center"
  >
    <!-- modal -->
    <div
      id="modal"
      class="flex items-center justify-center z-50 transform -translate-y-full scale-150 relative bg-opacity-100 w-3/4 h-[200px] shadow-2xl bg-gray-200 rounded-3xl transition-transform duration-300"
    >
      <div class="text-center text-4xl">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlarmFixPopup',

  data () {
    return {

    }
  },

  mounted () {
    console.log(this.$route.name)
    const modalOverlay = document.querySelector('#modal_overlay')
    const modal = document.querySelector('#modal')
    const modalCl = modal.classList
    const overlayCl = modalOverlay
    overlayCl.classList.remove('hidden')
    setTimeout(() => {
      modalCl.remove('opacity-0')
      modalCl.remove('-translate-y-full')
      modalCl.remove('scale-150')
    }, 100)
  },

  methods: {

  }
}
</script>
<style lang="css" scoped>
.backdrop {
  backdrop-filter: blur(5px);
}

</style>
